module.exports = __webpack_public_path__ + "images/emoji/sunny.f305fa1df01d182f5fe1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sunny.png
// module id = kikY
// module chunks = 13